function clearEventListeners(type) {
    var StStCustomEventsStore = window.StStCustomEventsStore;
    if (StStCustomEventsStore.hasOwnProperty(type)) {
        StStCustomEventsStore[type].forEach(function (callback) {
            return document.removeEventListener(type, callback);
        });
        delete StStCustomEventsStore[type];
    }
}
export function unsubscribe(type, callback) {
    if (callback) {
        document.removeEventListener(type, callback);
        return;
    }
    clearEventListeners(type);
}
//# sourceMappingURL=unsubscribe.js.map